<template>
    <p class="clearfix mb-0">
        <span class="float-md-left d-block d-md-inline-block mt-25">
          COPYRIGHT  © {{ new Date().getFullYear() }}
          <b-link
              class="ml-25 position-relative"
              href="https://chemity.eu"
              target="_blank"
          >
              <img :src="logo" height="18" alt="logo" class="position-absolute"/>
              <span class="ml-2">Chemity</span>
          </b-link>
          <span class="d-none d-sm-inline-block">, All rights Reserved</span>
        </span>

        <PrivacyPolicyLink class="float-right"/>
    </p>
</template>

<script>
import {BLink, BImg} from 'bootstrap-vue'
import {$themeConfig} from '@themeConfig'
import PrivacyPolicyLink from "@core/components/common/PrivacyPolicyLink.vue";

export default {
    components: {
        PrivacyPolicyLink,
        BLink,
        BImg
    },
    data() {
        return {
            logo: $themeConfig.app.appLogoWhiteImage
        };
    }
}
</script>
